export * from "./courseType";
export * from "./dayOfWeek";
export * from "./documentType";
export * from "./emojis";
export * from "./lessonType";
export * from "./rescheduleFee";

export const MAX_COURSE_DOCUMENT_FILE_SIZE = 300;
export const MAX_NUMBER_OF_COURSE_DOCUMENT = 9;
export const MAX_COURSE_NAME_LENGTH = 50;
export const MAX_COURSE_DESCRIPTION_LENGTH = 1000;
